import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import S from '../UI/variables';

export const StyledSidebar = styled.ul`
  position: relative;
  margin-top: 36px;
  border-radius: 5px;
  background: #fff;
  box-shadow: ${S.brockerCardShade};
  overflow: hidden;
  & a:not(.active) {
    height: 0px;
    overflow: hidden;
  }
  &.expanded {
    & .icon {
      transform: rotate(270deg);
    }
    & a {
      height: 44px;
    }
  }
  transition: height ${S.trFast};
  & > li {
    cursor: pointer;
    &.icon {
      position: absolute;
      display: flex;
      & > svg {
        margin: auto;
        pointer-events: none;
      }
      width: 24px;
      height: 24px;
      top: 10px;
      right: 10px;
      cursor: pointer;
      transform: rotate(90deg);
      transition: transform ${S.trFast};
    }
  }
  @media screen and (min-width: ${S.desktop}) {
    width: 197px;
    height: auto;
    margin-top: 0;
    & > li.icon {
      display: none;
    }
    & a:not(.active) {
      height: 44px;
    }
  }
`;

export const StyledSidebarLink = styled(NavLink)`
  display: block;
  line-height: 44px;
  padding-left: 16px;
  font-weight: 400;
  color: ${S.mainBlackText};
  transition: font-weight ${S.trFast}, color ${S.trFast}, height ${S.trFast};
  &:hover,
  &:focus {
    color: ${S.accentGold};
  }
  &.active: {
    color: ${S.accentGold};
  }
  &.visited: {
    color: initial;
  }
  &.active {
    font-weight: 600;
    color: ${S.accentGold};
  }
`;
